module.exports = __webpack_public_path__ + "static/media/promote.0ca740b0.svg";